import { IneligibilityByOfferingListRequestQuery } from '@lio/api-types';

export const offeringIneligibilityQueryKey = {
  search: ['ineligibility'] as const,
  searchWithParams: (params: IneligibilityByOfferingListRequestQuery) =>
    [...offeringIneligibilityQueryKey.search, params] as const,
};
